import {useTileAnimation, type TileProps} from './types'

export const Tile4 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'rect',
    scaleProperty: 'scale',
    transformOrigin: 'center',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <rect width="400" height="155" transform="matrix(-1 0 0 1 400 -3.55859)" fill={colors[0]} />
      <rect x="180.257" y="-4.55859" width="53.6287" height="52.3207" fill={colors[1]} />
      <rect x="126.629" y="46.4541" width="53.6287" height="52.3207" fill={colors[1]} />
      <rect x="233.886" y="46.4541" width="53.6287" height="52.3207" fill={colors[1]} />
      <rect x="73" y="98.1211" width="53.6287" height="52.3207" fill={colors[1]} />
      <rect x="180.257" y="98.1211" width="53.6287" height="52.3207" fill={colors[1]} />
      <rect x="287.515" y="98.1211" width="53.6287" height="52.3207" fill={colors[1]} />
    </svg>
  )
}
